export const AI_REVIEW_SETTINGS_ROUTE = '/api/ai-review-settings';
